// import React, { useState, useEffect } from "react";

// const formatToDisplay = (iso) => {
//   if (!iso) return "";
//   const [year, month, day] = iso.split("-");
//   return `${day}/${month}/${year}`;
// };

// const DatePickerDMY = ({
//   value,
//   onChange,
//   label,
//   min,
//   max,
//   placeholder = "DD/MM/YYYY",
// }) => {
//   const [displayDate, setDisplayDate] = useState("");

//   useEffect(() => {
//     setDisplayDate(formatToDisplay(value));
//   }, [value]);

//   return (
//     <div className="d-flex flex-column gap-1">
//       {label && <span className="fw-semibold">{label}</span>}
//       <div className="position-relative">
//         <span
//           className="position-absolute top-50 start-0 translate-middle-y ps-3"
//           style={{
//             pointerEvents: "none",
//             zIndex: 2,
//             color: displayDate ? "#212529" : "#6c757d",
//             fontSize: "1rem",
//             whiteSpace: "nowrap",
//             backgroundColor: "white",
//             width: "calc(100% - 2.5rem)",
//           }}
//         >
//           {displayDate || placeholder}
//         </span>
//         <input
//           type="date"
//           className="form-control"
//           style={{ color: "transparent", caretColor: "transparent" }}
//           value={value || ""}
//           min={min}
//           max={max}
//           onChange={(e) => {
//             const iso = e.target.value;
//             setDisplayDate(formatToDisplay(iso));
//             onChange(iso);
//           }}
//         />
//       </div>
//     </div>
//   );
// };

// export default DatePickerDMY;

import React, { useRef } from "react";

const DatePickerDMY = ({ value, onChange, label, min }) => {
  const ddRef = useRef();
  const mmRef = useRef();
  const yyyyRef = useRef();
  const hiddenRef = useRef();

  const parse = (iso) => {
    if (!iso) return { d: "", m: "", y: "" };
    const [y, m, d] = iso.split("-");
    return { d: parseInt(d), m: parseInt(m), y };
  };

  const { d, m, y } = parse(value);

  const buildISO = (dd, mm, yyyy) => {
    if (dd && mm && yyyy && String(yyyy).length === 4)
      return `${yyyy}-${String(mm).padStart(2, "0")}-${String(dd).padStart(2, "0")}`;
    return "";
  };

  const handleChange = (dd, mm, yyyy) => {
    const iso = buildISO(dd, mm, yyyy);
    if (iso) onChange(iso);
  };

  return (
    <div className="d-flex flex-column gap-1">
      {label && <span className="fw-semibold">{label}</span>}
      <div
        className="d-flex align-items-center border rounded"
        style={{ width: "fit-content", overflow: "hidden" }}
      >
        <input
          ref={ddRef}
          type="number"
          min="1"
          max="31"
          placeholder="DD"
          defaultValue={d}
          style={{
            width: 40,
            border: "none",
            outline: "none",
            textAlign: "center",
            padding: "6px 0",
          }}
          onChange={(e) => {
            if (e.target.value.length >= 2) mmRef.current.focus();
            handleChange(
              e.target.value,
              mmRef.current.value,
              yyyyRef.current.value,
            );
          }}
        />
        <span className="text-secondary">/</span>
        <input
          ref={mmRef}
          type="number"
          min="1"
          max="12"
          placeholder="MM"
          defaultValue={m}
          style={{
            width: 40,
            border: "none",
            outline: "none",
            textAlign: "center",
            padding: "6px 0",
          }}
          onChange={(e) => {
            if (e.target.value.length >= 2) yyyyRef.current.focus();
            handleChange(
              ddRef.current.value,
              e.target.value,
              yyyyRef.current.value,
            );
          }}
        />
        <span className="text-secondary">/</span>
        <input
          ref={yyyyRef}
          type="number"
          min="2024"
          max="2099"
          placeholder="YYYY"
          defaultValue={y}
          style={{
            width: 56,
            border: "none",
            outline: "none",
            textAlign: "center",
            padding: "6px 0",
          }}
          onChange={(e) => {
            handleChange(
              ddRef.current.value,
              mmRef.current.value,
              e.target.value,
            );
          }}
        />
        <button
          style={{
            border: "none",
            borderLeft: "0.5px solid #ccc",
            background: "transparent",
            padding: "6px 10px",
            cursor: "pointer",
          }}
          onClick={() => hiddenRef.current.showPicker()}
        >
          📅
        </button>
        <input
          ref={hiddenRef}
          type="date"
          min={min}
          style={{
            position: "absolute",
            opacity: 0,
            pointerEvents: "none",
            width: 0,
            height: 0,
          }}
          onChange={(e) => {
            const [yr, mo, da] = e.target.value.split("-");
            ddRef.current.value = parseInt(da);
            mmRef.current.value = parseInt(mo);
            yyyyRef.current.value = yr;
            onChange(e.target.value);
          }}
        />
      </div>
    </div>
  );
};

export default DatePickerDMY;